import it from './languages/it'
import en from './languages/en'

export const messages = {
    it,
    en
}